import type { ClienteApi } from '../cliente';
import { consulta, negocio } from '../comun';
import type { components } from '../tipos/analitica';

/**
 * Operaciones de Inicio (7.1) con su `operationId` y los tipos generados de `analitica.yaml`. La serie de un indicador
 * (`queryIndicator`) está en `ops/indicadores.ts` y Inicio la usa de ahí.
 */
type Esquema<N extends keyof components['schemas']> = components['schemas'][N];

export type TarjetaHoy = Esquema<'TodayCard'>;
export type PanelInicio = Esquema<'Dashboard'>;
export type TarjetaPanel = Esquema<'DashboardCard'>;
export type CifraPanel = Esquema<'DashboardItem'>;

export function operacionesAnalitica(api: ClienteApi) {
    return {
        /** getTodayCard (`analitica.hoy.ver`): «Hoy» del día local del negocio; cada cifra según su ámbito. */
        getTodayCard: (businessId: string) => api.pedir<TarjetaHoy>('GET', `${negocio(businessId)}/analytics/today`),
        /**
         * getDashboard (`analitica.panel.ver`): tarjetas «Periodo», «Canales» y «Campañas». Sin `compare`, frente al periodo
         * anterior (G430); solo las cifras que la persona puede leer.
         */
        getDashboard: (businessId: string, periodo: 'last_7_days' | 'last_30_days' | 'this_month' = 'last_7_days') =>
            api.pedir<PanelInicio>('GET', `${negocio(businessId)}/analytics/dashboard${consulta({ period: periodo })}`),
    };
}
